import { Button } from '../ui/Button';

type ErrorItem = { code: string; message: string; retryable: boolean };

type Props = {
  errors: ErrorItem[];
  onRetry?: (code: string) => void;
};

export function ErrorRecoveryCenter({ errors, onRetry }: Props) {
  if (errors.length === 0) {
    return <p className="text-sm text-slate-500">No open errors.</p>;
  }
  return (
    <ul className="space-y-2">
      {errors.map((e) => (
        <li key={e.code} className="rounded-lg border border-error-200 bg-error-50/50 p-3 dark:border-error-900 dark:bg-error-950/30">
          <p className="font-mono text-xs font-semibold text-error-800 dark:text-error-200">{e.code}</p>
          <p className="mt-1 text-sm text-slate-700 dark:text-slate-300">{e.message}</p>
          <div className="mt-2 flex gap-2">
            {e.retryable && (
              <Button variant="secondary" size="sm" onClick={() => onRetry?.(e.code)}>Retry</Button>
            )}
            <Button variant="ai" size="sm">AI Diagnose</Button>
          </div>
        </li>
      ))}
    </ul>
  );
}
